<!-- компонент для выбора образа ОС в создании VDS -->
<template>
	<div class="template-wrapper" :class="{ 'in-view': action === 'view' }">

		<!--
			Навигатор
		-->
		<div v-if="tabsData && Object.keys(tabsData).length && templateGroupsCommon && templateGroupsCommon.length" class="w5-vds-plan-list-filter-wrapper" :class="action">
			<span v-for="group in templateGroupsCommon"
				v-if="group && group.id && group.name && tabsData[group.id]"
				:key="group.id"
				class="w5-vds-plan-list-filter first"
				:class="{ 'active': currentTab == group.id, 'not-active-group': group.active === false }"
				@click.prevent.stop="handleTabChange(group.id)">
					{{ group.name | ftc }}
			</span>
		</div>
		<!-- ================ -->

		<!--
			Шаблоны
		-->
		<div class="w5-vds-plan-list-block template">

			<template v-if="tabsData && tabsData[currentTab]">

				<!-- Простые шаблоны -->
				<template v-if="currentTab != 'backup' && currentTab != 'iso'">
					<template v-if="tabsData[currentTab].list && tabsData[currentTab].list.length">
						<div v-for="(Template, idx) in tabsData[currentTab].list"
							v-if="isTemplateVisible(Template)"
							:key="'temp' + idx + String(Template.name)"
							class="w5-vds-plan-list-item template_id"
							:class="{
								'not-active-item': !isActiveTemplate(Template),
								'not-for-current-plan': action === 'view' && isNotTemplateForPlan(Template),
								'for-users': $store.state.user_type === 'client',
								'selected': isSelectedVersion(Template.list)
							}"
							@click.prevent.stop="handleClick(Template.name)">

							<!-- верхняя, общая часть -->
							<div class="w5-vds-plan-list-item-up twi"
								:class="{
									'full-and-round': Template.list.length <= 0 || (Template.list.length === 1 && !Template.list[0].version)
								}">
								<img :src="APIServerUrl + Template.image" width="64" />
								<div class="gourp-title">
									<strong>{{ Template.name }}</strong>
								</div>
							</div>

							<!-- нижняя -->
							<!-- если шаблонов несколько - нужен селектор -->
							<div v-if="Template.list.length > 1" class="w5-vds-plan-list-item-down template_id" :class="{ 'border-none': Template.showList }" style="position: relative">
								<div class="corner" :class="{ 'for-open-block': Template.showList }"></div>
								<div v-if="Template.showList" class="selector">
									<!-- версия шаблона - конкретный шаблон -->
									<div v-for="(temp, idx) in Template.list"
										v-if="temp.version"
										:class="{
											'last': idx === Template.list.length - 1,
											'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || (action === 'view' && isNotTemplateForPlan(temp))
										}"
										@click.prevent.stop="handleSelectTemplate(temp)">
										{{ temp.version }}
									</div>
								</div>
								<span v-else-if="isSelectedVersion(Template.list)" class="item-with-only-text">{{ isSelectedVersion(Template.list).version }}</span>
								<span v-else class="item-with-only-text">{{ 'template/select_version' | ftc }}</span>						
							</div>

							<!-- если в списке всего один шаблон и с установленной версией -->
							<div v-else-if="Template.list.length === 1 && Template.list[0].version" class="w5-vds-plan-list-item-down template_id">
								<span class="item-with-only-text">{{ Template.list[0].version }}</span>
							</div>

						</div>
					</template>
					<span v-else class="empty-message">{{ 'main/empty_table' | ftc }}</span>
				</template>

				<!-- Бэкапы -->
				<template v-else-if="currentTab == 'backup'">
					<div v-if="tabsData[currentTab].list && tabsData[currentTab].list.length" class="w5-field removeRightPadding">
						<backupChoiceComponent
							v-model="tabsData[currentTab].value"
							:action="action"
							:list="tabsData[currentTab].list"
							:plan="currentPlan"
							:datacenters="dataCenterField && dataCenterField.list && dataCenterField.list.length ? dataCenterField.list : []"
							:dc="dataCenterField && 'value' in dataCenterField ? dataCenterField.value : (dc ? dc : null)"
							@focus="onTabComponentFocus"
							@input="onSelectBackup" />
					</div>
					<div v-else class="empty-backup-list" style="width: 100%; margin-top: 20px">
						<span v-if="!dataCenterField || !dataCenterField.value" class="empty-message">
							{{ 'datacenter/not_selected' | ftc }}
						</span>
						<span v-else-if="accountField && accountField.value" class="empty-message">
							{{ 'service/backup_list_empty' | ftc }}
						</span>
						<span v-else class="empty-message" style="display: inline-block">{{ 'main/empty_table' | ftc }}</span>
					</div>
					<div style="width: 100%; margin-bottom: 20px">
						<a v-if="AppName === 'vdsina'" href="https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
							{{ 'backup/hint_how_to_make' | ftc }}
						</a>
						<a v-if="AppName === 'vdsina.com'" href="https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
							{{ 'backup/hint_how_to_make' | ftc }}
						</a>
						<a v-else-if="AppName === 'macloud'" href="https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera" target="_blank" rel="noopener noreferrer">
							{{ 'backup/hint_how_to_make' | ftc }}
						</a>
					</div>
				</template>

				<!-- ISO -->
				<template v-else-if="currentTab == 'iso'">
					<div v-if="tabsData[currentTab].list && tabsData[currentTab].list.length" class="w5-field removeRightPadding">
						<isoChoiceComponent
							v-model="tabsData[currentTab].value"
							:list="tabsData[currentTab].list"
							@focus="onTabComponentFocus"
							@input="onSelectIso" />
					</div>
					<div v-else class="empty-backup-list" style="width: 100%; margin-top: 20px">
						<span class="empty-message">{{ 'main/empty_table' | ftc }}</span>
					</div>
					<div style="width: 100%; margin-bottom: 20px">
						<a v-if="AppName === 'vdsina'" href="https://vdsina.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds" target="_blank" rel="noopener noreferrer">
							{{ 'iso/hint_how_to_use' | ftc }}
						</a>
						<a v-if="AppName === 'vdsina.com'" href="https://vdsina.com/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds" target="_blank" rel="noopener noreferrer">
							{{ 'iso/hint_how_to_use' | ftc }}
						</a>
						<a v-else-if="AppName === 'macloud'" href="https://macloud.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds" target="_blank" rel="noopener noreferrer">
							{{ 'iso/hint_how_to_use' | ftc }}
						</a>
					</div>
				</template>
			</template>
			<span v-else class="empty-message">{{ 'main/empty_table' | ftc }}</span>

		</div>



	</div>	
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Vue from 'vue'
import { EventBus } from '@/bus.js'
import Multiselect from 'vue-multiselect'
import backupChoiceComponent from '@/components/elements/backup'
import isoChoiceComponent from '@/components/elements/isoChoice'
import debounce from 'debounce'
///////////////////////////////////////////////////////////////////////////////
// TODO: нужно адаптировать данный компонент для вкладки переустановки ОС
// в просмотре VDS
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'templateNewComponent',
	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: ['formFields', 'planField', 'action', 'cookieValue', 'dc'],
	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущая вкладка - если пустая, то не показывается
			currentTab: '',

			// значения для каждой вкладки
			tabsData: {},

			// данные из другого компонента
			// ID текущего выбранного тарифного плана
			currentPlan: null,
			// данные текущего выбранного тарифного плана
			currentPlanData: null,

			// флаг - была ли инициализация первоначального значения
			initValieInitiated: false,

			// флаг
			counterPlanChanged: 0
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// группы шаблонов от API
		templateGroups() {
			const list = this.$store.state.lastTemplateGroupCache || []
			if (this.$store.state.user_type === 'admin') return list

			return list.filter(g => g && g.id && g.active)
		},

		// общая группа - шаблоны бэкапы и iso
		templateGroupsCommon() {
			const list = this.templateGroups && this.templateGroups.length
				? this.templateGroups.slice()
				: []

			let _found = false
			list.some(g => {
				if (g && g.id === 'backup')
				{
					_found = true
					return true
				}
			})
			if (!_found)
			{
				list.push({
					id: 'backup',
					name: 'service/backup',
					active: true
				})
			}

			_found = false
			list.some(g => {
				if (g && g.id === 'iso')
				{
					_found = true
					return true
				}
			})
			if (!_found)
			{
				list.push({
					id: 'iso',
					name: 'service/service_iso',
					active: true
				})
			}

			return list
		},

		// поле аккаунта
		accountField() {
			let field = this.findField('account_id')
			if (!field)
			{
				if (this.$store.state.user_account)
				{
					const _accountID = parseInt(String(this.$store.state.user_account).replace(/[a-z]/ig, ''), 10)
					if (!isNaN(_accountID) && _accountID > 0)
					{
						field = {
							name: 'account_id',
							value: _accountID
						}
					}
				}
			}

			return field
		},

		// поле ДЦ
		dataCenterField() {
			let field = this.findField('datacenter_id')
			if (!field)
			{
				if (this.dc)
				{
					field = {
						name: 'datacenter_id',
						title: 'datacenter/datacenter',
						list: [{
							id: this.dc
						}],
						value: this.dc
					}
				}
			}

			return field
		}
	},
	//=========================================================================
	// event
	//=========================================================================
	created() {
		// debounce
		this.tabListChanged = debounce(this.tabListChanged, 200)

		if (this.action === 'view')
		{
			// сразу переинициализация всех вкладок
			// так как они не будут меняться (обработчик watch не вызовется)
			this.initTabsData()

			// в просмотре тарифный план сразу задан
			if (this.planField)
			{
				this.currentPlan = this.planField.value

				if (this.planField.value && this.planField.list && this.planField.list.length)
				{
					this.planField.list.some(p => {
						if (p && p.id === this.planField.value)
						{
							this.currentPlanData = p
							return true
						}
					})
				}
			}
		}
	},
	//=========================================================================
	// event
	//=========================================================================
	mounted() {
		// подписка на сообщения - изменение выбранного тарифного плана
		EventBus.$on('w5-new-vds-plan-notice', this.handleChangePlan)
		// подписка на сообщение - запрос на смену текущей вкладки
		EventBus.$on('w5-change-active-tab', this.handleChangeActiveTab)

		// перегрузка списка поля - требуется использовать такой механизм
		// так как данные не плоские, и свойства не создаются observable
		EventBus.$on('w5-vds-create-field-reloaded', this.handleFieldReloaded)

		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
	},
	//=========================================================================
	// event
	//=========================================================================
	beforeDestroy() {
		// отписка от сообщений
		EventBus.$off('w5-new-vds-plan-notice', this.handleChangePlan)
		EventBus.$off('w5-change-active-tab', this.handleChangeActiveTab)
		EventBus.$off('w5-vds-create-field-reloaded', this.handleFieldReloaded)

		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация данных для всех вкладок
		//---------------------------------------------------------------------
		initTabsData() {
			// если нет данных - поля формы
			if (!this.formFields || !this.formFields.length)
			{
				return
			}

			this.initTemplates()
			this.initBackups()
			this.initIsos()

			this.initCurrentTab()

			// если еще не было инициализации первоначального значения
			if (!this.initValieInitiated)
			{
				let field = this.findField('template_id')
				if (field && field.list)
				{
					// ставим флаг что бы не повторяло
					this.initValieInitiated = true

					// значение для установки
					let _findValue = field.value
					// если задано cookieValue
					if (this.cookieValue)
					{
						_findValue = this.cookieValue
					}

					// установим первоначальное значение
					this.findSupportedTemplate(_findValue, field.list)
				}
			}
		},

		//---------------------------------------------------------------------
		// получает имя шаблона и версию из наименования шаблона
		//---------------------------------------------------------------------
		getNameAndVersion(Name) {
			// "WireGuard VPN Web (Ubuntu 22)"
			// "IPsec VPN (CentOS 7)"
			let matches = Name.match(/^(.*)\((.*)\)$/)
			if (matches && matches.length >= 3)
			{
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim()
				}
			}

			// "Ubuntu 20.04"
			// "CentOS 8-2"
			// "Windows Server 2019"
			matches = Name.match(/^([a-zA-Z.-\s]+)([0-9.-]+)$/)
			if (matches && matches.length >= 3)
			{
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim()
				}
			}

			// "Ubuntu 22.04 GPU"
			// "Windows Server 2022 GPU"
			// "Windows Server 2012 R2"
			matches = Name.match(/^([a-zA-Z.-\s]+)([0-9.-]+)([a-zA-Z.-\s0-9]+)$/)
			if (matches && matches.length >= 4)
			{
				return {
					name: String(matches[1]).trim(),
					version: String(matches[2]).trim() + ' ' + String(matches[3]).trim()
				}
			}

			// ответ по умолчанию
			return {
				name: Name,
				version: false
			}
		},

		//---------------------------------------------------------------------
		// инициализация данных для вкладки с шаблонами ОС
		//---------------------------------------------------------------------
		initTemplates() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим исходное поле с шаблонами
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let field = this.findField('template_id')
			if (!field || !field.list || !field.list.length)
			{
				return
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// начинаем собирать
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// флаг - если обнулили список
			let _listReset = {}

			// по каждому элементу
			for (let idx in field.list)
			{
				// текущий шаблон
				const template = field.list[idx]

				// если пустой шаблон
				if (!template || !template.name || !template.image || !template.id || !('template_group' in template))
				{
					continue
				}

				// получим отдельно наименование шаблона и его версию
				let nameAndVersion = this.getNameAndVersion(template.name)

				// если не удалось определить
				if (!nameAndVersion || !nameAndVersion.name)
				{
					// пропускаем такой шаблон
					continue
				}

				// найдем самму группу шаблонов
				let templateGroup = null
				if (this.templateGroups && this.templateGroups.length)
				{
					this.templateGroups.some(group => {
						if (group && (group.id === 99999 || group.id === template.template_group))
						{
							templateGroup = group
							return true
						}
					})
				}

				// если группы нет - пропускаем
				if (!templateGroup || !templateGroup.id || !templateGroup.name)
				{
					continue
				}

				// tab
				const tab = templateGroup.id

				// проверим вкладку группы шаблонов
				if (!this.tabsData[tab])
				{
					this.$set(this.tabsData, tab, {
						active: templateGroup.active,
						title: templateGroup.name,
						list: [],
						tab: tab,
						value: null,
						oldValue: null
					})
					_listReset[tab] = true
				}
				else
				{
					if (!_listReset[tab])
					{
						_listReset[tab] = true
						this.tabsData[tab].list = []
					}
				}

				// ищем шаблон по его наименованию
				let tempNameGroup = null
				this.tabsData[tab].list.some(temp => {
					if (temp.name === nameAndVersion.name)
					{
						tempNameGroup = temp
						return true
					}
				})

				// если так и не нашли
				if (!tempNameGroup)
				{
					// создадим новую группу
					this.tabsData[tab].list.push({ name: nameAndVersion.name })
					// снова ищем - так как нам нужна ссылка на объект
					this.tabsData[tab].list.some(temp => {
						if (temp.name === nameAndVersion.name)
						{
							tempNameGroup = temp
							return true
						}
					})
				}

				// записываем общие данные
				// открытый список версий или нет
				tempNameGroup.showList = false
				// картинка шаблона
				tempNameGroup.image = template.image
				// список версий данного шаблона
				if (!('list' in tempNameGroup) || !tempNameGroup.list) tempNameGroup.list = []

				// ищем по id
				let _find = tempNameGroup.list.some(i => String(i.id) === String(template.id))
				// если нашли - пропускаем
				if (_find) continue

				// если это сотрудник - фильтрация неактивных не нужна
				if (this.$store.state.user_type === 'admin')
				{
					// добавляем все версии в список шаблона
					tempNameGroup.list.push({
						id: template.id,
						fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
						version: nameAndVersion.version,
						active: template.active,
						sshkey: template.sshkey,
						plans: template.plans,
						limits: template.limits
					})
				}
				// если это клиент - нужно отфильтровать неактивные версии
				else
				{
					// активные передаем все
					if (template.active)
					{
						// добавим версию в список
						tempNameGroup.list.push({
							id: template.id,
							fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
							version: nameAndVersion.version,
							active: template.active,
							sshkey: template.sshkey,
							plans: template.plans,
							limits: template.limits
						})
					}
					// неактивная версия
					else
					{
						// добавим только если это редактирование или просмотр
						if (this.action === 'update' || this.action === 'view')
						{
							// и если это выбранная ранее версия
							if (String(field._oldValue) === String(template.id))
							{
								// только тогда добавим версию в список
								tempNameGroup.list.push({
									id: template.id,
									fullName: nameAndVersion.name + (nameAndVersion.version ? ' ' + nameAndVersion.version : ''),
									version: nameAndVersion.version,
									active: template.active,
									sshkey: template.sshkey,
									plans: template.plans,
									limits: template.limits
								})
							}
						}
					}
				}

				// если задано значение в поле - проставим его
				if (field.value &&
					tempNameGroup &&
					tempNameGroup.list &&
					tempNameGroup.list.length)
				{
					tempNameGroup.list.some(i => {
						if (String(i.id) === String(field.value))
						{
							this.tabsData[tab].value = i.id
							return true
						}
					})
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// инициализация данных для вкладки с бэкапами
		//---------------------------------------------------------------------
		async initBackups() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// инициализация начальных данных
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.tabsData || !this.tabsData['backup'])
			{
				this.$set(this.tabsData, 'backup', {
					title: 'service/backup',
					list: [],
					tab: 'backup',
					value: null,
					oldValue: null
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим исходное поле с бэкапами
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let field = this.findField('backup_id')
			if (!field) return

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это просмотр и нет заголовка, значит поля такого нет
			// а есть заглушка
			// нужно самим запросить список бэкапов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.action === 'view' && !field.title)
			{
				field.type = 'list'
				field.title = 'service/backup'
				field.reload = ['account_id', 'datacenter_id']
				field.list = []

				// запросим список бэкапов сами
				if (this.accountField && this.accountField.value &&
					this.dataCenterField && this.dataCenterField.value)
				{
					const _result = await this.$http.get(Vue.APIServerUrl + `/service/create?search=backup&datacenter_id=${this.dataCenterField.value}&account_id=${this.accountField.value}`)
					if (_result &&
						_result.body &&
						_result.body.status === 'ok' &&
						_result.body.result &&
						_result.body.result.length)
					{
						field.list = _result.body.result.filter(backup => {
							// если нет общих данных
							if (!backup ||
								!backup.id ||
								!backup.name ||
								!backup.active ||
								!backup.enable ||
								!backup.plans ||
								!backup.plans.length)
							{
								return false
							}

							// если нет текущего плана в списке
							if (backup.plans.indexOf(this.currentPlan) === -1)
							{
								return false
							}

							// если размер диска не подходит
							if (this.currentPlanData &&
								this.currentPlanData.data &&
								this.currentPlanData.data.disk)
							{
								let size = 'total' in this.currentPlanData.data.disk && this.currentPlanData.data.disk.total
									? this.currentPlanData.data.disk.total
									: this.currentPlanData.data.disk.value
								size = parseInt(size, 10)
								if (!isNaN(size) && size > 0)
								{
									if (backup.limits && backup.limits.disk && backup.limits.disk.min > size)
									{
										return false
									}
								}
							}

							// все подходит
							return true
						})

						// передадим список бэкапов в родительский компонент
						this.$emit('backupList', field.list)
					}
				}
			}

			this.tabsData['backup'].title = field.title

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим список бэкапов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.tabsData['backup'].list = field.list

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если список не пустой и есть указание
			// по выбору бэкапа (создание VDS из резервной копии)
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (field.list && field.list.length && window && window.sessionStorage)
			{
				let _crtFromBackup = window.sessionStorage.getItem('create-vds-from-backup')
				if (_crtFromBackup)
				{
					// сразу обнулим хранилище
					window.sessionStorage.removeItem('create-vds-from-backup')

					// конвертируем
					let _crtStore = null
					try {
						_crtStore = JSON.parse(_crtFromBackup)
					}
					catch (e)
					{
						_crtStore = null
					}

					// если бэкап задан
					if (_crtStore && _crtStore.service_id)
					{
						// проверим его наличие в списке
						field.list.some(b => {
							if (b && String(b.id) === String(_crtStore.service_id))
							{
								// сменим таб
								this.currentTab = 'backup'
								// сообщим о смене вкладки - родитель должен подгрузить список в компоненте Update
								this.$emit('templateTab', this.tabsData[this.currentTab].tab)
								// установим значение
								this.tabsData[this.currentTab].value = b.id
								// сообщим родителю о смене значения
								this.$emit('templateInput', {
									tab: this.tabsData[this.currentTab].tab,
									value: this.tabsData[this.currentTab].value
										? String(this.tabsData[this.currentTab].value)
										: this.tabsData[this.currentTab].value
								})
								// сообщим тарифу что сменили шаблон
								EventBus.$emit(
									'w5-new-vds-template-notice-what',
									this.findBackupById(this.tabsData[this.currentTab].value)
								)
								return true
							}
						})
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// инициализация данных для вкладки с ISO
		//---------------------------------------------------------------------
		initIsos() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// инициализация начальных данных
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (!this.tabsData || !this.tabsData['iso'])
			{
				this.$set(this.tabsData, 'iso', {
					title: 'service/service_iso',
					list: [],
					tab: 'iso',
					value: null,
					oldValue: null
				})
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим исходное поле с бэкапами
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			let field = this.findField('iso_id')
			if (!field) return

			this.tabsData['iso'].title = field.title

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// получим список бэкапов
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			this.tabsData['iso'].list = field.list

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// инициализация текущей вкладки
		//---------------------------------------------------------------------
		initCurrentTab() {
			// если значение уже задано
			if (this.currentTab)
			{
				// проверим наличие вкладки
				if (this.tabsData && this.tabsData[this.currentTab] && this.tabsData[this.currentTab].tab)
				{
					// если есть - все ок
					this.$emit('templateTab', this.tabsData[this.currentTab].tab)
					return
				}
			}

			// ищем первую вкладку с данными
			for (let t in this.templateGroupsCommon)
			{
				const group = this.templateGroupsCommon[t]

				if (group && group.id && this.tabsData[group.id] && this.tabsData[group.id].list && this.tabsData[group.id].list.length)
				{
					this.currentTab = group.id
					this.$emit('templateTab', this.tabsData[this.currentTab].tab)
					return
				}
			}
		},

		//---------------------------------------------------------------------
		// обработчик события изменения плана
		//---------------------------------------------------------------------
		handleChangePlan(data) {
			// проверка
			if (!this.tabsData || !this.currentTab || !this.tabsData[this.currentTab])
			{
				// рано
				return
			}

			// здесь всегда берем указанный
			if (this.action === 'view')
			{
				// в просмотре тарифный план сразу задан
				if (this.planField)
				{
					this.currentPlan = this.planField.value

					// если это уже тариф
					if (this.planField.data && 'cost' in this.planField)
					{
						this.currentPlanData = this.planField
					}
					else if (this.planField.value && this.planField.list && this.planField.list.length)
					{
						this.planField.list.some(p => {
							if (p && p.id === this.planField.value)
							{
								this.currentPlanData = p
								return true
							}
						})
					}
				}

				return
			}

			// проверка
			if (!data || !data.id || !data.plan)
			{
				// тариф пришел пустой
				this.currentPlan = null
				this.currentPlanData = null

				if (this.counterPlanChanged > 0)
				{
					// шаблон значит тоже обнуляем
					this.$emit('templateInput', {
						tab: this.tabsData[this.currentTab].tab,
						value: null
					})
				}

				this.counterPlanChanged++

				// на этом тут все
				return
			}

			// получим ID тарифа
			let planId = parseInt(data.id)
			if (isNaN(planId))
			{
				// тариф пришел некорректный
				this.currentPlan = null
				this.currentPlanData = null

				// шаблон значит тоже обнуляем
				this.$emit('templateInput', {
					tab: this.tabsData[this.currentTab].tab,
					value: null
				})

				// на этом тут все
				return
			}

			// запоминаем текущий тарифный план
			this.currentPlan = planId
			this.currentPlanData = data.plan

			// что с текущим выбранным шаблоном
			if ('value' in this.tabsData[this.currentTab] &&
				this.tabsData[this.currentTab].value !== null &&
				this.tabsData[this.currentTab].value !== undefined)
			{
				// текущий выбранный шаблон
				const templateValue = this.tabsData[this.currentTab].value
				// найдем его
				const template = this.findTemplateById(templateValue)
				// узнаем поддерживает этот шаблон текущий тариф или нет
				if (template && template.plans && template.plans.length)
				{
					// если нет в списке - сбросим
					if (template.plans.indexOf(this.currentPlan) === -1)
					{
						this.$emit('templateInput', {
							tab: this.tabsData[this.currentTab].tab,
							value: null
						})
					}
				}
			}
		},

		//---------------------------------------------------------------------
		// обработчик события изменения активной вкладки - запрос на изменение
		//---------------------------------------------------------------------
		handleChangeActiveTab(extTabName) {
			if (!this.tabsData) return

			let tab = ''
			for (let t in this.tabsData)
			{
				if (this.tabsData[t].tab === extTabName)
				{
					tab = t
					break
				}
			}

			if (!tab || this.currentTab === tab) return
			this.$nextTick(() => this.handleTabChange(tab, false))
		},

		//---------------------------------------------------------------------
		// поиск поля по имени
		//---------------------------------------------------------------------
		findField(fieldName) {
			if (!this.formFields ||
				!this.formFields.length)
			{
				return null
			}

			let _field = null
			this.formFields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === fieldName)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},

		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// нажали клавишу ESC
			if (e.keyCode === 27)
			{
				// закрываем все селекторы
				this.handleClick(null)
			}
		},

		//---------------------------------------------------------------------
		// обработка клика по документу
		//---------------------------------------------------------------------
		clickHandler(e) {
			// закрываем все селекторы
			this.handleClick(null)
		},

		//---------------------------------------------------------------------
		// кликнули по группе шаблонов
		//---------------------------------------------------------------------
		handleClick(templateName) {
			if (!this.tabsData) return

			// здесь запомним группу шаблонов по которой кликнули
			let selected = null

			// закрываем все списки версий шаблонов
			for (let t in this.tabsData)
			{
				// пропускаем бэкапы и ISO
				if (t === 'backup' || t === 'iso') continue

				// если есть список шаблонов
				if (this.tabsData[t] &&
					this.tabsData[t].list &&
					this.tabsData[t].list.length)
				{
					this.tabsData[t].list.forEach(item => {
						// если по этой группе кликнули
						if (templateName === item.name) selected = item
						// закрываем все селекторы
						item.showList = false
					})
				}
			}

			// проверим выбранную группу шаблонов
			if (selected && selected.list)
			{
				if (this.action === 'view')
				{
					// если там всего одна версия
					if (selected.list.length === 1)
					{
						// тогда сразу выберем ее - только если есть шаблон с планом
						if (!this.isNotTemplateForPlan(selected))
						{
							let temp = selected.list[0]
							if (temp && temp.id) this.setValue(temp.id, true)
						}
					}
					// значений несколько
					else
					{
						// открываем селектор - только если есть шаблон с планом
						if (!this.isNotTemplateForPlan(selected))
							selected['showList'] = true
						else
							selected['showList'] = false
					}
				}
				else
				{
					// если там всего одна версия
					if (selected.list.length === 1)
					{
						// тогда сразу выберем ее
						let temp = selected.list[0]
						if (temp && temp.id) this.setValue(temp.id, true)
					}
					// значений несколько
					else
					{
						// открываем селектор
						selected['showList'] = true
					}
				}
			}

			// обновим интерфейс - так как структура данных у нас не плоская
			// и не навешаны observers (I know, it's a bad practice)
			this.$forceUpdate()
		},

		//---------------------------------------------------------------------
		// обработка клика по конкретному шаблону в селекторе (список версий)
		//---------------------------------------------------------------------
		handleSelectTemplate(Template) {
			// проверка
			if (!Template || !Template.id || !Template.plans || !Template.plans.length) return

			// в просмотре - дополнительно проверим
			if (this.action === 'view')
			{
				// если не поддерживается тарифом
				if (this.isNotTemplateForPlan(Template)) return
			}

			// установка значения
			this.setValue(Template.id, true)
			// закрытие всех шаблонов
			this.handleClick(null)
		},

		//---------------------------------------------------------------------
		// активна ли вся группа шаблонов со всеми версиями
		//---------------------------------------------------------------------
		isActiveTemplate(Template) {
			// проверка параметра
			if (!Template || !Template.list || !Template.list.length)
			{
				return false
			}

			// если есть хотя бы один активный шаблон в текущей группе
			return Template.list.some(el => {
				if (el && el.id && el.active === true)
					return true
			})
		},

		//---------------------------------------------------------------------
		// есть ли в заданном списке выбранный шаблон, если есть - вернем шаблон
		//---------------------------------------------------------------------
		isSelectedVersion(List) {
			if (!List || !List.length) return false

			let answer = false
			List.some(el => {
				if (el && String(el.id) === String(this.tabsData[this.currentTab].value))
				{
					answer = el
					return true
				}
			})

			return answer
		},

		//---------------------------------------------------------------------
		// проверяет: все ли шаблоны в группе НЕ поддерживают текущий план
		//---------------------------------------------------------------------
		isNotTemplateForPlan(Template) {
			// если нет входящего параметра
			if (!Template) return true
			// если нет плана - никто не поддерживает его
			if (!this.currentPlan) return true

			// если это сразу пришел конкретный шаблон
			if (Template && Template.id && Template.fullName && Template.plans)
			{
				// список планов пустой
				if (!Template.plans.length) return true

				// если текущий план не в списке поддерживаемых
				if (Template.plans.indexOf(this.currentPlan) < 0) return true

				// если в списке поддерживаемых - проверим на лимиты
				if (Template.limits &&
					Template.limits.cpu && 'min' in Template.limits.cpu &&
					Template.limits.disk && 'min' in Template.limits.disk &&
					Template.limits.ram && 'min' in Template.limits.ram)
				{
					// если есть лимиты
					// но нет данных по лимитам плана - считаем что не поддерживает
					if (!this.currentPlanData ||
						!this.currentPlanData.data ||
						!this.currentPlanData.data.cpu ||
						!this.currentPlanData.data.disk ||
						!this.currentPlanData.data.ram)
					{
						return true
					}

					// есть лимиты и есть текущие данные тарифа - сверяемся
					// если хотя бы по одному параметру не подходит
					if (this.currentPlanData.data.cpu.value < Template.limits.cpu.min) return true
					else if (this.currentPlanData.data.disk.value < Template.limits.disk.min) return true
					else if (this.currentPlanData.data.ram.value < Template.limits.ram.min) return true

					// прошли все лимиты - значит поддерживается
					return false
				}
				else
				{
					// если лимитов вообще нет - значит нашли как минимум один
					// шаблон который поддерживает текущий план
					return false
				}
			}
			// пришла группа шаблонов
			else if (Template && Template.name && Template.list)
			{
				// список версий пустой
				if (!Template.list.length) return true

				// ищем в группе хотя бы один шаблон, который поддерживает план
				// и инвертируем результат
				return !Template.list.some(item => {
					// если текущий план есть в списке поддерживаемых
					if (item && item.plans && item.plans.length && item.plans.indexOf(this.currentPlan) > -1)
					{
						// проверим на лимиты
						// если лимитов нет - сразу понятно что нашли который поддреживает
						if (!item.limits) return true
						// иначе сверяемся с текущим планом
						if (item.limits &&
							item.limits.cpu && 'min' in item.limits.cpu &&
							item.limits.disk && 'min' in item.limits.disk &&
							item.limits.ram && 'min' in item.limits.ram)
						{
							// если нет еще плана
							if (!this.currentPlanData) return false

							// если тариф - конструктор
							if (this.currentPlanData.has_params)
							{
								// если нет данных по лимитам плана - считаем что не поддерживает
								if (!this.currentPlanData.params ||
									!this.currentPlanData.params.cpu ||
									!this.currentPlanData.params.disk ||
									!this.currentPlanData.params.ram)
								{
									return false
								}

								// есть лимиты и есть текущие данные тарифа - сверяемся
								// если хотя бы по одному параметру не подходит
								if (this.currentPlanData.params.cpu.value < item.limits.cpu.min) return false
								else if (this.currentPlanData.params.disk.value < item.limits.disk.min) return false
								else if (this.currentPlanData.params.ram.value < item.limits.ram.min) return false
							}
							// простой тариф
							else
							{
								// если нет данных по лимитам плана - считаем что не поддерживает
								if (!this.currentPlanData.data ||
									!this.currentPlanData.data.cpu ||
									!this.currentPlanData.data.disk ||
									!this.currentPlanData.data.ram)
								{
									return false
								}

								// есть лимиты и есть текущие данные тарифа - сверяемся
								// если хотя бы по одному параметру не подходит
								if (this.currentPlanData.data.cpu.value < item.limits.cpu.min) return false
								else if (this.currentPlanData.data.disk.value < item.limits.disk.min) return false
								else if (this.currentPlanData.data.ram.value < item.limits.ram.min) return false
							}

							// прошли все лимиты - значит поддерживается
							return true
						}
						// если данные по лимитам некорректны - считаем что поддерживает
						else return true
					}
				})
			}

			// если это бэкап
			if (Template && Template.id && Template.name && Template.plans && this.currentTab === 'backup')
			{
				// список планов пустой
				if (!Template.plans.length) return true

				// если текущий план не в списке поддерживаемых
				if (Template.plans.indexOf(this.currentPlan) < 0) return true

				// если в списке поддерживаемых - проверим на лимиты
				if (Template.limits &&
					Template.limits.cpu && Template.limits.cpu.min &&
					Template.limits.disk && Template.limits.disk.min &&
					Template.limits.ram && Template.limits.ram.min)
				{
					// если есть лимиты
					// но нет данных по лимитам плана - считаем что не поддерживает
					if (!this.currentPlanData ||
						!this.currentPlanData.data ||
						!this.currentPlanData.data.cpu ||
						!this.currentPlanData.data.disk ||
						!this.currentPlanData.data.ram)
					{
						return true
					}

					// есть лимиты и есть текущие данные тарифа - сверяемся
					// если хотя бы по одному параметру не подходит
					if (this.currentPlanData.data.cpu.value < Template.limits.cpu.min) return true
					else if (this.currentPlanData.data.disk.value < Template.limits.disk.min) return true
					else if (this.currentPlanData.data.ram.value < Template.limits.ram.min) return true

					// прошли все лимиты - значит поддерживается
					return false
				}
				else
				{
					// если лимитов вообще нет - значит нашли как минимум один
					// шаблон который поддерживает текущий план
					return false
				}
			}

			// если это iso
			if (Template && Template.id && Template.name && this.currentTab === 'iso')
			{
				// всегда поддерживается
				return false
			}

			return true
		},

		//---------------------------------------------------------------------
		// виден ли шаблон
		//---------------------------------------------------------------------
		isTemplateVisible(Template) {
			// проверка параметра - список версий должен быть всегда
			// даже если версия всего одна
			if (!Template || !Template.list || !Template.list.length)
			{
				return false
			}

			// для сотрудников все видно
			if (this.$store.state.user_type === 'admin') return true

			// для клиентов производим фильтрацию по следующим правилам:
			// 1) при создании услуги - неактивные варианты не должны быть доступны
			// 2) при редактировании:
			// 2.1) должны отображаться только если они изначально выбраны
			// 2.2) если выбрано что-то другое - не должны отображаться
			if (this.action === 'create')
			{
				// 1) если в группе нет ни одного активного шаблона - невидим
				if (!this.isActiveTemplate(Template)) return false
			}
			else if (this.action === 'update' || this.action === 'view')
			{
				// 2.2) если есть хотя бы одна активная версия - всяко видно
				if (this.isActiveTemplate(Template)) return true
				// если все версии неактивны - может какая то из них равна начальному значениию?
				else
				{
					// ищем поле что бы получить начальное значение
					let field = this.findField('template_id')
					if (!field || !field._oldValue)
					{
						return false
					}

					return Template.list.some(el => {
						if (String(field._oldValue) === String(el.id)) return true
					})
				}
			}

			// по умолчанию передаем все итемы
			return true
		},

		//---------------------------------------------------------------------
		// изменение таба пользователем
		//---------------------------------------------------------------------
		handleTabChange(newTabName, emitChanged = true) {
			// эмуляция фокуса
			this.$emit('focus')

			// если вкладка не поменялась
			if (this.currentTab === newTabName) return

			// если такой вкладки нет
			if (!this.tabsData || !this.tabsData[newTabName] || !this.tabsData[newTabName].tab)
				return

			// закрываем все селекторы (списки в шаблонах с версиями)
			this.handleClick(null)

			// сохраним в локальный кеш значение старой вкладки
			this.tabsData[this.currentTab].oldValue = this.tabsData[this.currentTab].value

			// меняем значение таба (вкладку)
			this.currentTab = newTabName

			// сразу оповестим родителя
			// о смене вкладки - родитель должен подгрузить списке в компоненте Update
			if (emitChanged)
			{
				this.$emit('templateTab', this.tabsData[this.currentTab].tab)
			}

			// проверим локальный кеш в новой вкладке
			if (this.tabsData[this.currentTab].oldValue)
			{
				this.tabsData[this.currentTab].value = this.tabsData[this.currentTab].oldValue
			}

			// если значения не оказалось - нужно найти первый активный
			if (!this.tabsData[this.currentTab].value)
			{
				if (this.tabsData && this.tabsData[this.currentTab] && this.tabsData[this.currentTab].list)
				{
					let found = false
					let list = this.tabsData[this.currentTab].list

					for (let key in list)
					{
						let obj = list[key]
						// если это шаблоны
						if (this.currentTab !== 'backup' && this.currentTab !== 'iso')
						{
							let template = obj
							if (template && template.list)
							{
								template.list.some(item => {
									// если нашли
									if (item.active === true)
									{
										// признак что нашли
										found = true
										// теперь только значение
										this.tabsData[this.currentTab].value = item.id
										// все
										return true
									}
								})
							}
						}
						// если это что то другое
						else
						{
							// оно должно быть активным
							if (obj && obj.id && obj.active === true && obj.enable === true)
							{
								// признак что нашли
								found = true
								// теперь только значение
								this.tabsData[this.currentTab].value = obj.id
							}
						}

						// если нашли - то все
						if (found) break
					}
				}
				else
				{
					// список пустой - сброс значения
					this.setValue(null, true)
					return
				}
			}
			else
			{
				// значение есть - нужно проверить его
			}

			// в просмотре - если есть значение, нужно проверить что оно подходит плану
			if (this.action === 'view')
			{
				// если есть значение
				if (this.tabsData[this.currentTab].value)
				{
					// найдем этот шаблон
					let template = this.findTemplateById(this.tabsData[this.currentTab].value)
					// если он не подходит плану - сбросим
					if (this.isNotTemplateForPlan(template))
					{
						this.setValue(null, true)
					}
				}
			}

			// и о смене значения тоже
			this.$emit('templateInput', {
				tab: this.tabsData[this.currentTab].tab,
				value: this.tabsData[this.currentTab].value
					? String(this.tabsData[this.currentTab].value)
					: this.tabsData[this.currentTab].value
			})

			// сообщаем о выбранном объекте
			if (this.currentTab !== 'backup' && this.currentTab !== 'iso')
			{
				EventBus.$emit(
					'w5-new-vds-template-notice-what',
					this.findTemplateById(this.tabsData[this.currentTab].value)
				)
			}
			else if (this.currentTab === 'backup')
			{
				EventBus.$emit(
					'w5-new-vds-template-notice-what',
					this.findBackupById(this.tabsData[this.currentTab].value)
				)
			}
			else if (this.currentTab === 'iso')
			{
				EventBus.$emit(
					'w5-new-vds-template-notice-what',
					this.findIsoById(this.tabsData[this.currentTab].value)
				)
			}
		},

		//---------------------------------------------------------------------
		// фокус на компоненте в табе
		//---------------------------------------------------------------------
		onTabComponentFocus() {
			this.$emit('focus')
		},

		//---------------------------------------------------------------------
		// поменялось значение поля "backup_id"
		//---------------------------------------------------------------------
		onSelectBackup(value) {
			// 	установим значение и сообщим родителям и в эфир
			this.setValue(value, true)
		},

		//---------------------------------------------------------------------
		// поменялось значение поля "iso_id"
		//---------------------------------------------------------------------
		onSelectIso(value) {
			// 	установим значение и сообщим родителям и в эфир
			this.setValue(value, true)
		},

		//---------------------------------------------------------------------
		// установка текущего значения
		//---------------------------------------------------------------------
		setValue(Value, needEmitInputEvent = false, needTemplateToBus = true) {
			// если нет текущих вкладок
			if (!this.tabsData || !this.tabsData[this.currentTab]) return

			this.tabsData[this.currentTab].valueName = null

			// если задали значение
			if (Value !== undefined && Value !== null)
			{
				// эмуляция фокуса
				this.$emit('focus')

				// присвоим значение
				let val = ''
				if (Value && typeof Value === 'object' && 'id' in Value)
					val = parseInt(Value.id)
				else
					val = parseInt(Value)

				if (!isNaN(val))
				{
					const _temp = this.findTemplateById(val)
					if (_temp)
					{
						if (_temp.fullName && (this.currentTab !== 'backup' && this.currentTab !== 'iso'))
						{
							this.tabsData[this.currentTab].valueName = _temp.fullName
						}

						this.tabsData[this.currentTab].value = val
						// сообщаем родителю что у нас поменялось значение
						if (needEmitInputEvent) this.$emit('templateInput', {
							tab: this.tabsData[this.currentTab].tab,
							value: String(val)
						})
						// передаем в эфир данные выбранного шаблона
						if (needTemplateToBus)
						{
							EventBus.$emit(
								'w5-new-vds-template-notice-what',
								_temp
							)
						}
					}
				}
			}
			else
			{
				this.tabsData[this.currentTab].value = null
				if (needEmitInputEvent) this.$emit('templateInput', {
					tab: this.tabsData[this.currentTab].tab,
					value: null
				})
				// передаем в эфир данные выбранного шаблона
				if (needTemplateToBus)
				{
					EventBus.$emit('w5-new-vds-template-notice-what', null)
				}
			}
		},

		//---------------------------------------------------------------------
		// ищем шаблон по его ID в текущем списке
		//---------------------------------------------------------------------
		findTemplateById(ID) {
			// только для шаблонов
			if (this.currentTab === 'backup' || this.currentTab === 'iso')
			{
				if (this.currentTab === 'backup')
					return this.findBackupById(ID)
				else if (this.currentTab === 'iso')
					return this.findIsoById(ID)
				else
					return null
			}
			// если нет данных
			if (!this.tabsData ||
				!this.tabsData[this.currentTab] ||
				!this.tabsData[this.currentTab].list ||
				!this.tabsData[this.currentTab].list.length)
			{
				return null
			}

			// готовим ответ
			let answer = null
			let list = this.tabsData[this.currentTab].list

			for (let key in list)
			{
				let template = list[key]
				if (template && template.list)
				{
					template.list.some(item => {
						if (String(item.id) === String(ID))
						{
							answer = item
							return true
						}
					})
				}

				if (answer) break
			}

			return answer
		},

		//---------------------------------------------------------------------
		// ищем бэкап по его ID в текущем списке
		//---------------------------------------------------------------------
		findBackupById(ID) {
			// только для бэкапов
			if (this.currentTab !== 'backup')
			{
				return null
			}

			// если нет данных
			if (!this.tabsData ||
				!this.tabsData[this.currentTab] ||
				!this.tabsData[this.currentTab].list ||
				!this.tabsData[this.currentTab].list.length)
			{
				return null
			}

			// готовим ответ
			let answer = null
			let list = this.tabsData[this.currentTab].list

			for (let key in list)
			{
				let obj = list[key]
				if (obj && String(obj.id) === String(ID))
				{
					answer = obj
					break
				}
			}

			return answer
		},

		//---------------------------------------------------------------------
		// ищем ISO по его ID в текущем списке
		//---------------------------------------------------------------------
		findIsoById(ID) {
			// только для ISO
			if (this.currentTab !== 'iso')
			{
				return null
			}

			// если нет данных
			if (!this.tabsData ||
				!this.tabsData[this.currentTab] ||
				!this.tabsData[this.currentTab].list ||
				!this.tabsData[this.currentTab].list.length)
			{
				return null
			}

			// готовим ответ
			let answer = null
			let list = this.tabsData[this.currentTab].list

			for (let key in list)
			{
				let obj = list[key]
				if (obj && String(obj.id) === String(ID))
				{
					answer = obj
					answer.__type = 'iso'
					break
				}
			}

			return answer
		},

		//---------------------------------------------------------------------
		// перезагрузилось поле
		// обычно это ситуация когда: мы находимся во вкладке бэкапов или исо
		// и просто меняем аккаунт
		//---------------------------------------------------------------------
		handleFieldReloaded(name) {
			if (name === 'backup_id' || name === 'iso_id')
			{
				this.initTabsData()

				// если текущие вкладки это шаблоны - на этом все
				if (this.currentTab !== 'backup' && this.currentTab !== 'iso')
					return

				// определим: требуется ли обнуление выбранного значения
				let reloadedFieldtab = ''
				if (name === 'backup_id' && this.tabsData && this.tabsData['backup'])
				{
					reloadedFieldtab = 'backup'
				}
				else if (name === 'iso_id' && this.tabsData && this.tabsData['iso'])
				{
					reloadedFieldtab = 'iso'
				}

				// ищем в списке старое значение, которое у нас до сих пор находится в поле "value"
				let found = false
				if (this.tabsData[reloadedFieldtab].list &&
					this.tabsData[reloadedFieldtab].list.length)
				{
					this.tabsData[reloadedFieldtab].list.some(item => {
						if (item && String(item.id) === String(this.tabsData[reloadedFieldtab].value))
						{
							found = item
							return true
						}
					})
				}

				// если найдено, то делать ничего не нужно - будет выбрано старое значение
				// а если не найдено и при этом было задано какое то значение - нужно обнулить его
				if (found === false && this.tabsData[reloadedFieldtab].value !== null)
				{
					this.tabsData[reloadedFieldtab].value = null

					this.$emit('templateInput', {
						tab: this.tabsData[reloadedFieldtab].tab,
						value: null
					})

					EventBus.$emit(
						'w5-new-vds-template-notice-what',
						null
					)
				}
			}
		},

		//---------------------------------------------------------------------
		// ищем первый, поддерживаемый текущим планом, шаблон
		// или если задано начальное значение - проверим что оно поддерживает план
		//---------------------------------------------------------------------
		findSupportedTemplate(initValue, initList) {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если задано начальное значение
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (initValue)
			{
				let temp = null

				// ищем его во всех шаблонах
				if (initList && initList.length)
				{
					// сначала найдем сам шаблон
					initList.some(t => {
						if (String(t.id) === String(initValue))
						{
							temp = t
							return true
						}
					})

					// если нашли и его флаг "active" = true
					if (temp && (temp.active === true || this.action === 'view'))
					{
						// ищем по всех вкладках, кроме бэкапов и исо
						for (let t in this.tabsData)
						{
							if (t === 'backup' || t === 'iso') continue

							// если есть список шаблонов
							if (this.tabsData[t] && this.tabsData[t].list)
							{
								let found = false
								let list = this.tabsData[t].list
								for (let key in list)
								{
									let template = list[key]
									if (template && template.list)
									{
										template.list.some(item => {
											// если нашли
											if (String(item.id) === String(temp.id))
											{
												// признак что нашли
												found = true
												// ставим вкладку
												this.currentTab = t
												// теперь только значение
												this.setValue(item, true)
												// все
												return true
											}
										})
									}

									// если нашли - то все
									if (found) return
								}
							}
						}
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// начального значения нет - ищем первый активный шаблон
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// ищем по всех вкладках, кроме бэкапов и исо
			for (let idx in this.templateGroupsCommon)
			{
				const group = this.templateGroupsCommon[idx]
				if (!group || !group.id) continue

				const t = group.id
				if (t === 'backup' || t === 'iso') continue
				if (!this.tabsData[t] || !this.tabsData[t].list) continue

				let found = false
				let list = this.tabsData[t].list
				for (let key in list)
				{
					let template = list[key]
					if (template && template.list)
					{
						template.list.some(item => {
							// если нашли
							if (item.active === true)
							{
								// признак что нашли
								found = true
								// ставим вкладку
								this.currentTab = t
								// теперь значение
								this.setValue(item, true)
								// начальные значения
								this.$emit('startData', String(item.id))
								// все
								return true
							}
						})
					}

					// если нашли - то все
					if (found) return
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},

		//---------------------------------------------------------------------
		// изменился список в табе
		//---------------------------------------------------------------------
		tabListChanged() {
			// только в текущей
			const tab = this.currentTab

			// если нет списка
			if (!tab ||
				!this.tabsData ||
				!this.tabsData[tab] ||
				!this.tabsData[tab].list ||
				!this.tabsData[tab].list.length)
			{
				return
			}

			// если нет значения
			if (!('value' in this.tabsData[tab]) || !this.tabsData[tab].value)
			{
				return
			}

			// есть ли старое наименование
			const _oldValueName = this.tabsData[tab].valueName

			// проверим - есть ли в списке текущее значение
			let _inList = false
			let _firstId = null

			this.tabsData[tab].list.some(temp => {
				if (temp && temp.list && temp.list.length)
				{
					return temp.list.some(i => {
						if (i && i.id)
						{
							// первое значение в списке
							if (!_firstId)
							{
								if (this.$store.state.user_type === 'admin')
									_firstId = i.id
								else if (i.active)
									_firstId = i.id
							}

							// если нашли значение в списке
							if (String(i.id) === String(this.tabsData[tab].value))
							{
								if (this.$store.state.user_type === 'admin')
									_inList = true
								else if (i.active)
									_inList = true

								if (_inList) return true
							}
						}
					})
				}
				else
				{
					if (temp && temp.id)
					{
						// первое значение в списке
						if (!_firstId)
						{
							if (this.$store.state.user_type === 'admin')
								_firstId = temp.id
							else if (temp.active)
								_firstId = temp.id
						}

						// если нашли значение в списке
						if (String(temp.id) === String(this.tabsData[tab].value))
						{
							if (this.$store.state.user_type === 'admin')
								_inList = true
							else if (temp.active)
								_inList = true

							if (_inList) return true
						}
					}
				}
			})

			// если не нашли
			if (!_inList)
			{
				// если есть старое наименование - ищем первое активное значение с таким же наименованием
				if (_oldValueName)
				{
					this.tabsData[tab].list.some(temp => {
						if (temp.list && temp.list.length)
						{
							return temp.list.some(i => {
								if (i.fullName === _oldValueName)
								{
									if (this.$store.state.user_type === 'admin')
									{
										_firstId = i.id
										return true
									}
									else if (i.active)
									{
										_firstId = i.id
										return true
									}
								}
							})
						}
					})
				}

				// вот теперь установим значение
				this.setValue(_firstId, true)
			}
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдаем изменение списка
	//=========================================================================
	watch: {
		'formFields': {
			handler: function() {
				this.initTabsData()
			},
			deep: true
		},
		'tabsData': {
			handler: function() {
				this.tabListChanged()
			},
			deep: true
		}
	},

	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Multiselect,
		backupChoiceComponent,
		isoChoiceComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.w5-vds-plan-list-filter-wrapper {
	/*margin: 10px 0 20px;*/
}

.w5-vds-plan-list-filter-wrapper.create,
.w5-vds-plan-list-filter-wrapper.view {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;
}

.w5-vds-plan-list-filter {
	display: inline-block;
	text-align: left;
	font-weight: 400;
	padding-bottom: 5px;
	cursor: pointer;
	font-size: 15px;
	transition: color .2s;
	margin-right: 20px;
}
.w5-vds-plan-list-filter:hover {
	color: #3ba3ff;
}
.w5-application.mc .w5-vds-plan-list-filter:hover {
	color: #1b379c;
}

.w5-vds-plan-list-filter.first {
	/*margin-right: 0;*/
}
.w5-vds-plan-list-filter.last {
	margin-left: 0;
	margin-right: 0;
}
.w5-vds-plan-list-filter.active {
	color: #2c8ad8;
	border-bottom: 2px solid #2c8ad8;
}
.w5-application.mc .w5-vds-plan-list-filter.active {
	color: #01196f;
	border-bottom: 2px solid #01196f;
}
.w5-vds-plan-list-filter.not-active-group {
	color: #999;
}
.w5-vds-plan-list-filter.active.not-active-group {
	border-bottom: 2px solid #999;
}

.w5-vds-plan-list-item-down.template_id {
	border-color: #ddd !important;
    padding: 0;
}

.w5-vds-plan-list-item.template_id {
	width: 130px;
	height: 156px;
	margin: 0;
	margin-right: 15px;
	margin-bottom: 0;
	margin-top: 20px;
}

.w5-vds-plan-list-item-down.template_id .selector {
    z-index: 100;
    position: relative;
    background: white;

    border-bottom: 1px solid #ddd !important;
    border-right: 1px solid #ddd !important;
    border-left: 1px solid #ddd !important;	
    border-radius: 0 0 4px 4px;
}
.w5-vds-plan-list-item:hover div.selector {
	border-color: #3ba3ff !important
}
.w5-application.mc .w5-vds-plan-list-item:hover div.selector {
	border-color: #1b379c !important
}

.w5-vds-plan-list-item.selected div.selector {
	border-color: #3ba3ff !important
}
.w5-application.mc .w5-vds-plan-list-item.selected div.selector {
	border-color: #1b379c !important
}

.w5-vds-plan-list-item-down.template_id .selector > div {
	padding: 10px;
}
.w5-vds-plan-list-item-down.template_id .selector > div.last {
	border-radius: 0 0 4px 4px;
}
.w5-vds-plan-list-item-down.template_id .selector > div.not-supported {
	color: #999;
}
.w5-vds-plan-list-item-down.template_id .selector > div:hover {
	background-color: #dceeff !important;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up {
	height: 110px;
}

.w5-vds-plan-list-item-up .gourp-title {
	line-height: 0.9;
	height: 26px;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	flex-direction: column;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up.full-and-round {
	height: 150px;
	border-radius: 4px !important;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up.twi.full-and-round {
	height: 156px;
	border-radius: 4px !important;
}

.w5-vds-plan-list-item.template_id > .w5-vds-plan-list-item-up.full-and-round .gourp-title {
	height: 66px;
	line-height: 1.2;
}

/* неактивная группа шаблонов */
.not-active-item > .w5-vds-plan-list-item-up,
.not-active-item > .w5-vds-plan-list-item-down {
	background-color: #f9f9f9;
}
.not-active-item.for-users {
	cursor: not-allowed;
}

/* блок который содержит только текст */
.item-with-only-text {
	height: 45px;
    display: block;
    line-height: 45px;
    overflow: hidden;
}

/* прочерк в нижней части группы шаблонов */
.item-with-only-line {
	height: 45px;
    display: block;
    line-height: 45px;
    text-align: center;
    padding-top: 21px;
    padding-left: 34px;
}
.item-with-only-line > .line {
	width: 50px;
	height: 1px;
	border-top: 1px solid #ddd;
}

/* засереная группа шаблонов */
.w5-vds-plan-list-item.template_id.not-for-current-plan {
	opacity: 0.7;
    filter: grayscale(1);
    cursor: not-allowed;
}
.not-for-current-plan > .w5-vds-plan-list-item-up > .gourp-title {
	color: #777;
}
.not-for-current-plan > .w5-vds-plan-list-item-down > .item-with-only-text {
	color: #777;
}
.w5-vds-plan-list-item.template_id.not-for-current-plan:hover div.w5-vds-plan-list-item-up {
	background-color: white !important;
    border-color: #ddd !important;
}
.w5-vds-plan-list-item.template_id.not-for-current-plan:hover div.w5-vds-plan-list-item-down {
    border-color: #ddd !important;
}

/* уголок селектора версий */
.corner {
	position: absolute;
	display: inline-block;

	border: 4px solid transparent;
	border-top: 5px solid #999;
	width: 0;
	height: 0;

	right: 10px;
	top: 20px;
	z-index: 1;
}
.corner.for-open-block {
	border-top: none;
	border-bottom: 5px solid #999;
	top: 18px;	
}

/* под мобилу */
@media (max-width: 380px) {
	.w5-vds-plan-list-filter {
		font-size: 14px;
		text-align: left;
		margin-top: 10px;
		/*width: 100%;*/
	}
	.w5-vds-plan-list-filter.first {
		margin-right: 0;
	}
	.w5-vds-plan-list-filter.last {
		margin-left: 0;
	}

	.w5-vds-plan-list-filter.active {
		font-weight: 500;
		/*border-bottom: none;*/
		padding-bottom: 0;
	}
}

@media (max-width: 767px) {
	.w5-vds-plan-list-filter-wrapper.create,
	.w5-vds-plan-list-filter-wrapper.view {
		flex-direction: column;
		align-items: stretch;
		-webkit-align-items: stretch;
	}

	.w5-vds-plan-list-filter.last {
		margin-left: 0;
	}

	.w5-vds-plan-list-filter {
		font-size: 14px;
		text-align: left;
		margin-top: 10px;

		display: inline-block;
	}
}
</style>

<style scoped>
.empty-backup-list .empty-message { display: inline-block }

.w5-field-placeholder {
	position: absolute;
	left: 20px;
	height: 45px;
	width: calc(100% - 30px);
	padding: 3px 0;
	line-height: 39px;
	font-weight: 400;
	color: #ccc;
	user-select: none;
	pointer-events: none;
	z-index: 0;
}

.w5-field-placeholder .required-field {
	color: #ccc;
}

.w5-field-placeholder.active {
	font-size: 75%;
	line-height: 1;
	color: #9f9f9f;
}

.w5-field-placeholder.active .required-field {
	color: red;
}

</style>



// WEBPACK FOOTER //
// tempNew.vue?9926af46